import React, {ReactNode} from "react";
import {Grid, Theme, useTheme} from "@mui/material";
import {SxProps} from "@mui/system";

export const buttonBarStyles = (theme: Theme) => ({
  display: 'flex',
  marginTop: theme.spacing(4),
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
});

export function FormButtonBar(props: {
  children?: ReactNode,
  sx?: SxProps<Theme>,
}) {
  const theme = useTheme();
  return (
    <Grid container={true} spacing={1} sx={props.sx ? props.sx : buttonBarStyles(theme)}>
      {props.children}
    </Grid>
  );
}
